import { render, staticRenderFns } from "./AddEditDeminimis.vue?vue&type=template&id=1d04aadc&scoped=true"
import script from "./AddEditDeminimis.vue?vue&type=script&lang=js"
export * from "./AddEditDeminimis.vue?vue&type=script&lang=js"
import style0 from "./AddEditDeminimis.vue?vue&type=style&index=0&id=1d04aadc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d04aadc",
  null
  
)

export default component.exports